import BaseInput from './Dashboard/SharedComponents/BaseInput.vue'
import BaseCheckbox from './Dashboard/SharedComponents/BaseCheckbox.vue'
import BaseRadio from './Dashboard/SharedComponents/BaseRadio.vue'
import BaseDropdown from './Dashboard/SharedComponents/BaseDropdown.vue'
import Card from './Dashboard/SharedComponents/Card.vue'

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (Vue) {
    Vue.component(BaseInput.name, BaseInput)
    Vue.component(BaseCheckbox.name, BaseCheckbox)
    Vue.component(BaseRadio.name, BaseRadio)
    Vue.component(BaseDropdown.name, BaseDropdown)
    Vue.component('card', Card)
  }
}

export default GlobalComponents
